import { useState } from "react";
import { useMutation } from "@tanstack/react-query"
import axios from "axios";
import { apiRoot } from "..";
import { Spinner } from "react-bootstrap";

const PasswordChange = () => {
  const [inputs, setInputs] = useState({});
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const changePasswordMutation = useMutation((passwords) => {
    return axios.post(apiRoot  + '/login/password', passwords);
  },
  {
    onSuccess: () => {
      setInputs({});
      setSuccessMessage('Změna hesla byla úspěšně provedena.');
      window.scrollTo(0, 0);
    },
    onError: (error) => {
      setErrorMessage(error.message); // TODO json -> errorCode -> hlaska
      window.scrollTo(0, 0);
    }
  });

  const handleChange = (event) => {
    if (!changePasswordMutation.isLoading) {
      const name = event.target.name;
      const value = event.target.value;
      setInputs(values => ({...values, [name]: value}))
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setErrorMessage(null);
    setSuccessMessage(null);

    if (!inputs.oldPass || !inputs.newPass1 || !inputs.newPass2) { // TODO trim
      setErrorMessage('Některé povinné položky nejsou vyplněné.');
      window.scrollTo(0, 0);
      // TODO zvyrazneni nevyplnenych vstupnich poli
      return;
    }

    if (inputs.newPass1 === inputs.oldPass) { // TODO trim
      setErrorMessage('Zadané nové heslo je stejné jako zadané aktuální heslo.');
      window.scrollTo(0, 0);
      // TODO zvyrazneni nevyplnenych vstupnich poli
      return;
    }

    // TODO newPass1 nesplnuje podminky - Zadané nové heslo neodpovídá požadavkům

    if (inputs.newPass1  !== inputs.newPass2) { // TODO trim
      setErrorMessage('Zadaná nová hesla nejsou stejná.');
      window.scrollTo(0, 0);
      // TODO zvyrazneni nevyplnenych vstupnich poli
      return;
    }

    changePasswordMutation.mutate(inputs);
  }

  return (
    <>
<div>
<span className="align-middle">
<i className="fa fa-key fa-3x fa-in-header align-middle" aria-hidden="true"></i>
<h2 className="d-inline-block align-middle">Změna hesla</h2>
</span>
</div>

<form onSubmit={handleSubmit}>

<table>
<tbody>
<tr>
<td>{errorMessage && <div className="alert alert-danger" role="alert">{errorMessage}</div>}{successMessage && <div className="alert alert-success" role="alert">{successMessage}</div>}</td>
</tr><tr>
<td>Požadavky na nové heslo:
<ul>
  <li>délka minimálně 6 znaků</li>
  <li>povolena jsou velká a malé písmena bez diakritiky a číslice</li>
  <li>alespoň jedno velké písmeno</li>
  <li>alespoň jedno malé písmeno</li>
  <li>alespoň jedna číslice</li>
</ul></td>
</tr><tr>
<td><strong>Aktuální heslo:</strong></td>
</tr><tr>
<td><input type="password" className="form-control" name="oldPass" size="30" value={inputs.oldPass || ""} onChange={handleChange} /></td>
</tr><tr>
<td>&nbsp;</td>
</tr><tr>
<td><strong>Nové heslo:</strong></td>
</tr><tr>
<td><input type="password" className="form-control" name="newPass1" size="30" value={inputs.newPass1 || ""} onChange={handleChange} /></td>
</tr><tr>
<td><strong>Zopakovat nové heslo:</strong></td>
</tr><tr>
<td><input type="password" className="form-control" name="newPass2" size="30" value={inputs.newPass2 || ""} onChange={handleChange} /></td>
</tr><tr>
<td>&nbsp;</td>
</tr><tr>
<td><button type="submit" className="btn btn-success" disabled={changePasswordMutation.isLoading}><i className="fa fa-key" aria-hidden="true"></i> Změnit heslo</button>
{changePasswordMutation.isLoading ? (<> <Spinner as="span" animation="border" size="sm" /></>) : (<></>)}</td>
</tr>
</tbody>
</table>

</form>
    </>
  );
};

export default PasswordChange;